import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getVideo,
  updateUserProgress,
  getAssignment,
  submitAssessment
} from "../../../../data-service";
import {
  getMisc,
  getBrightcoveAccountId
} from "../../../../localstorage-service";
import AssessmentModal from "./AssessmentModal";
import BrightcoveVideo from "./BrightcoveVideo";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";
import AssessmentInstructions from "./AssessmentInstructions";
import AssessmentQuestions from "./AssessmentQuestions";
import AssessmentResult from "./AssessmentResult";
import Spinner from "../../Common/Spinner/Spinner";
import * as CONSTANT from "../../../../constants";
// import { initBrightCovePlayer } from "../../../../utilities";

class VideoMain extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    prevState.isWorkflow = nextProps.isWorkflow;
    return prevState;
  }
  state = {
    videocategories: [],
    selectedVideo: {
      BrightcoveVideoId: 5788388399001,
      BrightcoveAccountId: getBrightcoveAccountId()
    },
    rightside: false,
    isWorkflow: false,
    showAssessment: false,
    startAssessment: false,
    questions: [],
    currentquestion: {},
    questionIndex: 0,
    isLastQuestion: false,
    answerIndex: -1,
    isAssessmentSubmitted: false,
    showSpinner: false,
    title: ""
  };

  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }

  setDataFromApiCall(response) {
    let vcs = response.data.videoList;
    let selectedVideo;
    if (vcs.length === 0) {
      alert("No videos found");
      this.props.history.goBack();
      return;
    }

    vcs = vcs.map((c, i) => {
      c.open = false;
      return c;
    });

    let isEverythingComplete = true;
    loop1: for (let i = 0; i < vcs.length; i++) {
      let timeArray = [];
      let vc = vcs[i];
      for (let j = 0; j < vcs[i].videos.length; j++) {
        let video = vcs[i].videos[j];
        timeArray.push(video.Time);
        video.Time = this.formatTime(video.Time);
        if (!video.IsComplete) {
          isEverythingComplete = false;
          selectedVideo = video;
          vc.open = true;
          break loop1;
        }
      }
      vcs[i].TotalTime = this.totalTime(timeArray);
    }

    if (isEverythingComplete) {
      selectedVideo = vcs[0].videos[0];
      vcs = vcs.map((c, i) => {
        c.open = true;
        return c;
      });
    }

    this.appendScript(getBrightcoveAccountId());

    this.setState({
      videocategories: vcs,
      selectedVideo: selectedVideo,
      hasAssessment: response.data.HasAssessment
    });
    this.videoClicked(this.state.selectedVideo);
  }

  totalTime(timeArray) {
    let sec = 0;
    for (let time of timeArray) {
      const timeSplitted = time.split(":");
      sec +=
        parseInt(timeSplitted[0], 10) * 60 * 60 +
        parseInt(timeSplitted[1], 10) * 60 +
        parseInt(timeSplitted[2], 10);
    }
    var date = new Date(1970, 0, 1);
    date.setSeconds(sec);
    return this.formatTime(
      date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1")
    );
  }
  formatTime(time) {
    const timeSplitted = time.split(":");
    if (timeSplitted[0] === "00") {
      return `${timeSplitted[1]}m ${timeSplitted[2]}s`;
    }
    return `${timeSplitted[0]}h ${timeSplitted[1]}m ${timeSplitted[2]}s`;
  }

  componentDidMount() {
    const categoryid = this.props.isWorkflow
      ? CONSTANT.WorkflowId
      : CONSTANT.LearningId;

    if (this.state.isWorkflow) {
      this.showSpinner(true);
      getVideo(categoryid)
        .then(response => {
          this.showSpinner(false);
          this.setState({ title: response.data.CategoryName });
          this.setDataFromApiCall(response);
        })
        .catch(error => {
          this.showSpinner(false);
          this.props.showError(error);
        });
    } else {
      const subcategoryid = this.props.match.params.id;
      this.showSpinner(true);
      getVideo(categoryid, subcategoryid)
        .then(response => {
          this.showSpinner(false);
          // console.log(response.data);
          if (!response.data.IsEnabled) {
            this.props.history.goBack();
            return;
          }
          this.setState({ title: response.data.SubCategoryName });
          this.setDataFromApiCall(response);
        })
        .catch(error => {
          this.showSpinner(false);
          this.props.showError(error);
        });
    }
  }

  appendScript(brightcoveAccountId) {
    const script = document.createElement("script");
    script.src = `https://players.brightcove.net/${brightcoveAccountId}/default_default/index.min.js`;
    script.async = true;
    script.onload = this.callback;
    document.body.appendChild(script);
  }

  callback() {
    // initBrightCovePlayer();
  }

  collapseClick(vcs, currentindex) {
    vcs[currentindex].open = !this.state.videocategories[currentindex].open;
    this.setState({ videocategories: vcs });
  }

  videoClicked(video) {
    this.setState({ selectedVideo: video });

    updateUserProgress({ VideoId: video.Id })
      .then(response => {
        let vcs = this.state.videocategories;
        vcs.forEach(vc => {
          vc.videos.forEach(v => {
            if (v.Id === video.Id) {
              v.IsComplete = true;
              v.IsActive = true;
            } else {
              v.IsActive = false;
            }
          });
        });
        this.setState({ videocategories: vcs });
      })
      .catch(error => {
        this.props.showError(error);
      });

    this.appendScript(getBrightcoveAccountId());
  }

  startAssessmentClicked() {
    this.showSpinner(true);
    const subcategoryid = this.props.match.params.id;
    getAssignment(subcategoryid)
      .then(response => {
        this.showSpinner(false);
        this.setState({
          startAssessment: true,
          questions: response.data.questions,
          currentquestion: response.data.questions[this.state.questionIndex]
        });
      })
      .catch(error => {
        this.showSpinner(false);
        this.props.showError(error);
      });
  }

  nextQuestionClicked() {
    const newQuestionIndex = this.state.questionIndex + 1;
    if (this.state.questions.length === newQuestionIndex + 1) {
      this.setState({ isLastQuestion: true });
    }
    this.setState({
      answerIndex: -1,
      currentquestion: this.state.questions[newQuestionIndex],
      questionIndex: newQuestionIndex
    });
  }

  submitAssessmentClicked() {
    // console.log(this.state.questions);
    this.showSpinner(true);
    submitAssessment({ questions: this.state.questions })
      .then(response => {
        this.showSpinner(false);
        // console.log(response.data);
        this.setState({
          answerIndex: -1,
          isAssessmentSubmitted: true,
          percentScored: (
            (response.data.UserScore / response.data.TotalScore) *
            100
          ).toFixed(2)
        });
      })
      .catch(error => {
        this.showSpinner(false);
        this.props.showError(error);
      });
  }

  answerClicked(id) {
    let questions = [...this.state.questions];
    questions[this.state.questionIndex].answers[id].IsUserAnswer = true;
    if (!this.state.isAssessmentSubmitted) {
      this.setState({ answerIndex: id, questions: questions });
    }
  }

  handleClose() {
    this.setState({
      showAssessment: false,
      startAssessment: false,
      questions: [],
      currentquestion: {},
      questionIndex: 0,
      isLastQuestion: false,
      answerIndex: -1,
      isAssessmentSubmitted: false
    });
  }

  render() {
    const title = this.state.title;
    let panelhtml = null;
    const vcs = this.state.videocategories;
    const isWorkflow = this.state.isWorkflow;
    let learninghtmlright = null;
    let selfassessmentright = null;
    let modalBodyHtml = null;

    if (vcs && vcs.length > 0) {
      if (!isWorkflow) {
        selfassessmentright = this.state.hasAssessment && (
          <div>
            <button
              className="toggle self-assessment-right"
              onClick={() => {
                this.setState({ showAssessment: true });
              }}
            >
              {getMisc("assessmenttitle")}
            </button>
          </div>
        );
        if (!this.state.startAssessment) {
          modalBodyHtml = (
            <AssessmentInstructions
              startAssessmentClicked={() => this.startAssessmentClicked()}
            />
          );
        } else {
          if (!this.state.isAssessmentSubmitted) {
            modalBodyHtml = (
              <AssessmentQuestions
                questionIndex={this.state.questionIndex}
                questions={this.state.questions}
                currentquestion={this.state.currentquestion}
                isAssessmentSubmitted={this.state.isAssessmentSubmitted}
                answerClicked={id => this.answerClicked(id)}
                isLastQuestion={this.state.isLastQuestion}
                submitAssessmentClicked={() => this.submitAssessmentClicked()}
                nextQuestionClicked={() => this.nextQuestionClicked()}
              />
            );
          } else {
            modalBodyHtml = (
              <AssessmentResult
                percentScored={this.state.percentScored}
                questions={this.state.questions}
                answerClicked={id => this.answerClicked(id)}
                isAssessmentSubmitted={this.state.isAssessmentSubmitted}
              />
            );
          }
        }
        if (this.state.selectedVideo.IntroImagePath) {
          learninghtmlright = (
            <RightPanel
              rightPanelClicked={() => this.setState({ rightside: true })}
              rightside={this.state.rightside}
              selectedVideo={this.state.selectedVideo}
              closeClicked={() => {
                this.setState({ rightside: false });
              }}
            />
          );
        }
      }
      panelhtml = vcs.map((category, index) => {
        return (
          <LeftPanel
            key={category.VideoCategoryId}
            category={category}
            index={index}
            collapseClick={() => this.collapseClick(vcs, index)}
            open={this.state.videocategories[index].open}
            time={`34m 43s`}
            videoClicked={video => this.videoClicked(video)}
          />
        );
      });
    }

    return (
      <Aux>
        <Spinner showSpinner={this.state.showSpinner} />
        {learninghtmlright}
        {selfassessmentright}
        <div className="container-fluid padrightzero">
          <div className="col-xs-12">
            <div className="row">
              <div className="col-lg-10 col-lg-push-2 col-md-9 col-md-push-3 col-sm-8 col-sm-push-4 padrightzero">
                <BrightcoveVideo
                  key={this.state.selectedVideo.BrightcoveVideoId}
                  brightcoveVideoId={this.state.selectedVideo.BrightcoveVideoId}
                  brightcoveAccountId={getBrightcoveAccountId()}
                />
              </div>
              <div className="col-lg-2 col-lg-pull-10 col-md-3 col-md-pull-9 col-sm-4 col-sm-pull-8">
                <div className="row">
                  <div className="row">
                    <div className="video_left_menu">
                      <div className="col-xs-12">
                        <div className="row">
                          <h5>{title}</h5>
                          {/* {assessmenthtml} */}
                        </div>
                        <div className="row">
                          <div className="card">
                            <div className="tab-content">
                              <div
                                role="tabpanel"
                                className="tab-pane active"
                                id="home"
                              >
                                <div
                                  className="panel-group"
                                  id="accordion"
                                  role="tablist"
                                  aria-multiselectable="true"
                                >
                                  {panelhtml}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AssessmentModal
          showAssessment={this.state.showAssessment}
          title={title}
          modalBodyHtml={modalBodyHtml}
          isAssessmentSubmitted={this.state.isAssessmentSubmitted}
          startAssessment={this.state.startAssessment}
          handleClose={() => this.handleClose()}
        />
      </Aux>
    );
  }
}

export default VideoMain;



// WEBPACK FOOTER //
// ./src/containers/User/Common/VideoMain/VideoMain.js